import script from "./LocationMixin.vue?vue&type=script&lang=js"
export * from "./LocationMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__